import { registerAll } from "./registry";
import { parseToPage, rewriteTags } from "rpml-parser";
import { liveRender, createDocRenderer } from "./core/live-render";
import { ModeManager, lightTheme, darkTheme } from "./core/mode";
import { CanvasController } from "./core/canvas-controller";

registerAll();

export {
  registerAll,
  parseToPage,
  rewriteTags,
  liveRender,
  createDocRenderer,
  ModeManager,
  CanvasController,
  lightTheme,
  darkTheme,
};
export type { LiveRenderOpts, DocRenderer } from "./core/live-render";
export type {
  RpuiTheme,
  RpuiMode,
  PickInfo,
  ModeManagerOpts,
  DarkScope,
} from "./core/mode";
export type { CanvasControllerOpts } from "./core/canvas-controller";

export {
  validateSource,
  validate,
  buildHtml,
  type ValidationError,
  type ValidationResult,
  type RpmlDoc,
  type BuildHtmlOpts,
} from "./tools";
export {
  SKILL,
  GENERATE_RPML_PROMPT,
  REVIEW_RPML_PROMPT,
  RPML_DIFF_IMPACT_PROMPT,
  RPML_TO_CODE_PROMPT,
  ELEMENT_INDEX,
  EXAMPLE_REFERENCE,
  PRACTISE,
  SPEC_SUMMARY,
  PROMPTS,
  REFERENCES,
  RAPID_PROTOTYPE_IMPLEMENT,
} from "./prompts";
